import React from "react";
import * as S from "./styles";
export var Help = function Help(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, e), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
    transform: "translate(-32 -248) translate(16 200) translate(0 32) translate(0 16) translate(16)"
  }, React.createElement("g", null, React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M12 .75C18.213.75 23.25 5.787 23.25 12S18.213 23.25 12 23.25.75 18.213.75 12 5.787.75 12 .75z"
  }), React.createElement("path", {
    strokeWidth: "0",
    fill: "currentcolor",
    d: "M10.592 14.272v-.608c0-.256.019-.485.056-.688.037-.203.096-.395.176-.576.08-.181.187-.357.32-.528.133-.17.301-.352.504-.544l.72-.688c.203-.181.376-.384.52-.608.144-.224.216-.496.216-.816 0-.416-.13-.765-.392-1.048-.261-.283-.632-.424-1.112-.424-.245 0-.467.045-.664.136-.197.09-.368.213-.512.368-.144.155-.253.333-.328.536-.075.203-.117.41-.128.624L8 9.232c.064-.512.2-.968.408-1.368.208-.4.477-.739.808-1.016.33-.277.71-.488 1.136-.632.427-.144.885-.216 1.376-.216.459 0 .893.067 1.304.2.41.133.773.33 1.088.592.315.261.563.584.744.968.181.384.272.827.272 1.328 0 .341-.037.64-.112.896-.075.256-.181.49-.32.704-.139.213-.307.419-.504.616s-.419.403-.664.616c-.213.181-.387.341-.52.48-.133.139-.24.277-.32.416-.08.139-.136.288-.168.448-.032.16-.048.357-.048.592v.416h-1.888zm-.32 2.224c0-.341.125-.635.376-.88.25-.245.552-.368.904-.368.341 0 .64.117.896.352s.384.523.384.864c0 .341-.125.635-.376.88-.25.245-.552.368-.904.368-.17 0-.333-.032-.488-.096-.155-.064-.29-.15-.408-.256-.117-.107-.21-.235-.28-.384-.07-.15-.104-.31-.104-.48z"
  })))))))));
};